export default __webpack_public_path__ + "static/media/kitchen4-afterE-1024w.cf0167c8.avif";